import React, { Component } from 'react';
import CSSModules from 'react-css-modules';
import style from './insight.scss';
import { Image, Row, Col, Button, Highcharts, Table } from '$common';
import Translate from './translate';
import Tooltip from 'rc-tooltip';
import 'rc-tooltip/assets/bootstrap.css';
import groupBy from 'lodash/groupBy';
import isEqual from 'lodash/isEqual';

@CSSModules(style, { allowMultiple: true })
export default class Insight extends Component {
  state = {
    type: this.props.type
  };

  content = null;

  componentWillMount() {
    this.renderContent(this.props, this.state);
  }

  componentWillReceiveProps(nextProps) {
    if (!isEqual(this.props, nextProps)) {
      this.setState({ type: nextProps.type });
      this.renderContent(nextProps, this.props);
    }
  }

  componentWillUpdate(nextProps, nextState) {
    if (!isEqual(this.state, nextState)) {
      this.setState({ type: nextState.type });
      this.renderContent(nextProps, nextState);
    }
  }

  renderContent(props, state) {
    state.type === "line" ?
      this.content = this.renderLine(props)
    : null

    state.type === "bar" || state.type === "column" ?
      this.content = this.renderBar(props, state)
    : null

    state.type === "pie" ?
      this.content = this.renderPie(props)
    : null

    state.type === "gallery" ?
      this.content = this.renderMedia(props)
    : null

    state.type === "demographics" ?
      this.content = this.renderDemographics(props)
    : null

    state.type === "set" ?
      this.content = this.renderSet(props)
    : null
    
    // state.type === "wordcloud" ?
    //   this.content = this.renderWordCloud(props)
    // : null
  }

  makeImageResizeURL(url, size) {
    if (process.target[0] === "production") {
      if (url.search('bounty-app') !== -1) {
        return url.replace('bounty-app.s3.amazonaws.com', `images2.twentify.com/${size}`);
      } else {
        return url.replace('celebi.s3.eu-central-1.amazonaws.com', `images.twentify.com/${size}`);
      }
    } else {
      return url;
    }
  }

  renderWordCloud(props) {
    const { data } = this.props;
    
    const config = {
      colors: this.colors,
      series: [{
        type: 'wordcloud',
        data: data.filter(i => i.weight >= 5),
        name: 'Occurrences',
        spiral: 'archimedean',
        style: {
          fontFamily: 'Open Sans',
          fontWeight: '600'
        }
      }],
      title: {
        text: ''
      },
      credits: {
        enabled: false
      }
    };

    return (<Highcharts config={config}/>)
  }

  renderLine(props) {
    const { data, questionType } = props;

    if (data.length > 0) {

      let orderedData = data.sort( (a, b) => {
        return questionType === "range" && Number(a.label) - Number(b.label) || a.count - b.count;
      });

      const line = orderedData.map( (item, index) => (
        <Tooltip placement="bottom" overlay={<span>{Translate.get('total')}, {item.count} {item.label} {Translate.get('given_an_answer')}</span>} key={index}>
          <span
            styleName="bar-item"
            style={{
              width: `${(item.count*100)/this.totalCount}%`,
              background: this.colors[index]
            }}
          >
            <span styleName="label">{Math.round((item.count*100)/this.totalCount)}%<br />{ (Math.round((item.count*100)/this.totalCount)) >= 6 ? item.label : ''}</span>
          </span>
        </Tooltip>
      ))
      return(line);
    }
  }

  renderMedia(props) {
    const { data, onImageClick } = props;
    const media = data.map( (item, index) => {
      return index <= 6 ?
        <Col md="1/7" gutter={10} key={index}>
          <a onClick={(e) => onImageClick(index, e)}>
            <Image
              source={::this.makeImageResizeURL(item.thumbnail, '150x150')}
              cover
              square
              hideOnLoad
            />
          </a>
        </Col>
        : ''
    });
    return(
      <div styleName="media">
        <Row>
          {media}
        </Row>
      </div>
    );
  }

  renderPie(props) {
    const pie = <Highcharts config={this.pieChartConfig(props)} style={{ paddingTop: '15px' }} />
    return (<div styleName="pie">{pie}</div>)
  }

  renderBar(props, state) {
    const { questionType } = props;

    const bar = (
      <Highcharts
        style={{ paddingTop: '15px' }}
        config={ questionType === 'ordering' && this.stackedColumnChartConfig(props) || this.barChartConfig(props, state) }
      />
    )
    return (<div styleName="pie">{bar}</div>)
  }

  renderDemographics(props) {
    const { data } = props;

    let ageGroups = {
      '18-24': 0,
      '25-29': 0,
      '30-34': 0,
      '35-39': 0,
      '40-44': 0,
      '45-49': 0,
      '50-54': 0,
      '55-99': 0,
    };

    Object.keys(data.ages).map(item => {
      const age = item;
      const count = data.ages[item] || 0;

      if ( age > 18 && age <= 24 ) {
        ageGroups['18-24'] += count;
      }

      if ( age > 25 && age <= 29 ) {
        ageGroups['25-29'] += count;
      }

      if ( age > 30 && age <= 34 ) {
        ageGroups['30-34'] += count;
      }

      if ( age > 35 && age <= 39 ) {
        ageGroups['35-39'] += count;
      }

      if ( age > 40 && age <= 44 ) {
        ageGroups['40-44'] += count;
      }

      if ( age > 45 && age <= 49 ) {
        ageGroups['45-49'] += count;
      }

      if ( age > 50 && age <= 54 ) {
        ageGroups['50-54'] += count;
      }

      if ( age > 55 && age <= 99 ) {
        ageGroups['55-99'] += count;
      }
    });

    const ages = Object.keys(ageGroups).map(item => ({ label: item, count: ageGroups[item]}));
    const genders = Object.keys(data.genders).map(item => ({ label: item, count: data.genders[item] }));
    const disableSort = true;

    return (
      <div styleName="pie" style={{ textAlign: 'center' }}>
        <Row>
          <Col md="1/2">
            <h4>{Translate.get('user_ages')}</h4>
            <Highcharts
              style={{ paddingTop: '15px' }}
              config={this.barChartConfig({ data: ages }, { type: 'bar' }, disableSort) }
            />
          </Col>

          <Col md="1/2">
            <h4>{Translate.get('user_gender')}</h4>
            <div styleName="audience">
              {
                genders.map((item, index) => item.label !== 'other' ? (
                  <div key={index} styleName="audience-item">
                    <img src={require(`$shared/images/audience/${item.label}.svg`)} />
                    <span>{item.count}</span>
                  </div>
                ) : null)
              }
            </div>
          </Col>
        </Row>
      </div>
    )
  }

  renderSet(props) {
    const { data } = props;

    return(
      <div>
        <Table
          showHeader={false}
          columns={[
            {
              label: '',
              content: item => <b>Set {item[0].absoluteIndex+1}</b>,
              width: `2/${String(data[0].length*3+1)}`
            },
            ...data[0].map((i, index) => ({
              label: '',
              content: item => item[String(index)][`var_${String(index)}`],
              width: `3/${String(data[0].length*3+1)}`,
              style: { textAlign: 'center' }
            }))
          ]}
          data={data.map((set, index) => (
            set.map((variable, varIndex) => ({ [`var_${varIndex}`]: variable, absoluteIndex: index })))
          )}
        />
      </div>
    );
  }

  switchChartType() {
    if (this.state.type === this.props.switchTo) {
      this.setState({ type: this.props.type });
    } else {
      this.setState({ type: this.props.switchTo });
    }
  }

  get colors() {
    if (process.muhimma.indexOf(process.target[0]) !== -1) {
      return [
        '#706f6f',
        '#f79421',
        '#E74C3C',
        '#2E0927',
        '#2980B9',
        '#FF8C00',
        '#04756F',
        '#FFA644',
        '#644D52',
        '#332532',
        '#3498DB',
        '#2C594F',
        '#E54661'
      ]
    } else {
      return [
        '#2C3E50',
        '#f79421',
        '#E74C3C',
        '#2E0927',
        '#2980B9',
        '#04756F',
        '#40407a',
        '#644D52',
        '#332532',
        '#218c74',
        '#5f27cd',
        '#576574'
      ];
    }
  }

  pieChartConfig(props) {
    const { data } = props;

    let chartConfig = {
      chart: {
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'pie'
      },
      title: {
        text: ''
      },
      tooltip: {
        pointFormat: '{point.percentage:.1f}% ({point.y})</b>'
      },
      colors: this.colors,
      sort: 'enabled',
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: true,
            format: '<b>{point.name}</b>: {point.percentage:.1f} %',
            style: {
              color: (Highcharts.theme && Highcharts.theme.contrastTextColor) || 'black'
            }
          }
        }
      },
      series: [{
        name: '',
        colorByPoint: true,
        data: []
      }],
      credits: {
        enabled: false
      }
    };
    
    let orderedData = data.sort( (a, b) => {
      return a.count - b.count;
    });

    orderedData.map((item, index) => {
      let words = item.label.split(' ');
      let label = '';
      if (words.length > 2) {
        words.splice(words.length/2, 0, '<br>');
        label = words.join(' ');
      } else {
        label = item.label;
      }
      chartConfig.series[0].data.push({ name: label, y: item.count, width: '100px' });
    });
    return chartConfig;
  }

  barChartConfig(props, state, disableSort = false) {
    const { data, questionType } = props;

    let chartConfig = {
      chart: {
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: state.type === 'bar' ? 'bar' : 'column'
      },
      title: {
        text: ''
      },
      xAxis: {
        type: 'category'
      },
      yAxis: {
        title: {
          text: ' '
        }
      },
      legend: {
        enabled: false
      },
      plotOptions: {
        series: {
          allowPointSelect: true,
          cursor: 'pointer',
          borderWidth: 0,
          dataLabels: {
            enabled: true,
            format: '{point.y}',
            style: {
              color: (Highcharts.theme && Highcharts.theme.contrastTextColor) || 'black'
            }
          }
        }
      },
      tooltip: {
        headerFormat: '',
        pointFormat: `${Translate.get('total')}: <b>{point.y}</b> <span style="color:{point.color}">{point.name}</span><br/>`
      },
      colors: this.colors,
      series: [{
        name: '',
        colorByPoint: true,
        data: []
      }],
      credits: {
        enabled: false
      }
    };

    if (!disableSort) {
      data.sort( (a, b) => {
        return questionType === "range" && Number(a.label) - Number(b.label) || a.count - b.count;
      });
    }

    data.map((item) => {
      let words = item.label.split(' ');
      let label = '';
      if (words.length > 4) {
        words.splice(words.length/2, 0, '<br>');
        label = words.join(' ');
      } else {
        label = item.label;
      }
      chartConfig.series[0].data.push({ name: label, y: item.count });
    });

    return chartConfig;
  }

  stackedColumnChartConfig(props) {
    const { data } = props;

    let chartConfig = {
      chart: {
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'column'
      },
      title: {
        text: ''
      },
      xAxis: {
        type: 'category',
        title: {
          text: 'Order'
        },
        categories: []
      },
      yAxis: {
        title: {
          text: 'Total Count'
        }
      },
      legend: {
        enabled: true,
        align: 'right',
        verticalAlign: 'top',
        y: 5,
        floating: false,
        backgroundColor: (Highcharts.theme && Highcharts.theme.background2) || 'white',
        borderColor: '#CCC',
        borderWidth: 1,
        shadow: false
      },
      plotOptions: {
        column: {
          stacking: 'normal',
          dataLabels: {
            enabled: true,
            color: (Highcharts.theme && Highcharts.theme.dataLabelsColor) || 'white'
          }
        }
      },
      tooltip: {
        headerFormat: '',
        pointFormat: `${Translate.get('total')}: <b>{point.y}</b> <span style="color:{point.color}">{point.name}</span><br/>`
      },
      colors: this.colors,
      series: [],
      credits: {
        enabled: false
      }
    };

    let orderedData = data.sort( (a, b) => {
      return parseInt(a.extra_payload) - parseInt(b.extra_payload);
    });

    let groupByLabel = groupBy(orderedData, 'label');

    Object.keys(groupByLabel).map((item, index) => {
      chartConfig.series.push({
        name: item,
        data: []
      });

      for (let i = 0; i < Object.keys(groupByLabel).length; i++) {
        if (groupByLabel[item][i] && groupByLabel[item][i].extra_payload !== i+1 || typeof groupByLabel[item][i] === "undefined") {
          groupByLabel[item].splice(i, 0, { name: item, count: null, extra_payload: i+1 })
        }
        chartConfig.series[index].data.push(groupByLabel[item][i] && groupByLabel[item][i].count)
      }

      chartConfig.xAxis.categories.push(index+1);
    });

    return chartConfig;
  }

  get icon() {
    if (this.state.type === 'line') {
      return 'pie';
    } else if(this.state.type === 'bar') {
      return 'column';
    } else {
      return 'bar';
    }
  }

  get totalCount() {
    const { type, questionType, data } = this.props;
    let totalCount = 0;

    if (type === 'gallery') {
      totalCount = data.length;
    } else if (questionType === 'ordering') {
      const groupedData = groupBy(data, 'label');
      groupedData[Object.keys(groupedData)[0]].map(i => totalCount += parseInt(i.count));
    } else {
      data.map( (item) => {
        totalCount += item.count;
      });
    }
    
    return totalCount;
  }

  get average() {
    const { data } = this.props;
    let total = 0;

    data.map( (item) => {
      total += Number(item.label) * item.count;
    });

    return total / this.totalCount;
  }

  render() {
    const { children, type, switchTo, questionType, hideCount } = this.props;

    return (
      <div styleName="root" id="answer">
        <div styleName="content">
          <Row>
            <Col md="7/8">
              {children}
              {
                !['demographics', 'wordcloud', 'set'].includes(type) && !hideCount ?
                  <small styleName="number-of-responses">
                    {Translate.get('number_of_responses')}: {this.totalCount}
                  </small>
                : null
              }
            </Col>
            <Col md="1/8" style={{ textAlign: 'right' }}>
              {
                switchTo ?
                  <Button
                    type="weak"
                    size="small"
                    onClick={this.switchChartType.bind(this)}
                  >
                    <img src={ require(`$shared/images/${this.icon}.svg`) } />
                  </Button>
                : null
              }
            </Col>
          </Row>
        </div>

        {
          questionType === 'range' &&
          <div styleName="average">
            <span>{Translate.get('average')}:</span>
            <span>{this.average.toFixed(2)}</span>
          </div>
        }

        {this.content}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/common/insight.js